import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginScreen() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { webLogin, webUser, mvirsUser, sessionLoading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    if (!sessionLoading) {
      if (webUser && mvirsUser) navigate('/dashboard');
      else if (webUser) navigate('/mvirs-login');
    }
  }, [webUser, mvirsUser, sessionLoading, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await webLogin(username, password);
      navigate('/mvirs-login');
    } catch (err) {
      const msg = err.response?.data?.error;
      setError(msg || 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.container}>
      <div style={s.card}>
        <h1 style={s.title}>MVIRS</h1>
        <p style={s.subtitle}>Motor Vehicle Inspection Record System</p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleLogin}>
          <div style={s.field}>
            <label style={s.label}>Username</label>
            <input
              style={s.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoCapitalize="none"
              autoCorrect="off"
              required
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>Password</label>
            <input
              style={s.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <div style={s.forgotRow}>
            <Link to="/forgot-password" style={s.link}>Forgot password?</Link>
          </div>

          <button style={loading ? s.buttonDisabled : s.button} type="submit" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div style={s.divider} />

        <p style={s.newAccountText}>Don't have an account?</p>
        <Link to="/create-account" style={s.createBtn}>
          Create Account
        </Link>
      </div>
    </div>
  );
}

const s = {
  container:      { minHeight: '100vh', backgroundColor: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card:           { backgroundColor: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' },
  title:          { textAlign: 'center', fontSize: '32px', fontWeight: 'bold', color: '#1a1a2e', margin: '0 0 8px 0' },
  subtitle:       { textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '32px' },
  field:          { marginBottom: '20px' },
  label:          { display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px', color: '#333' },
  input:          { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '16px', boxSizing: 'border-box', outline: 'none' },
  forgotRow:      { textAlign: 'right', marginBottom: '8px', marginTop: '-12px' },
  link:           { color: '#007AFF', fontSize: '14px', textDecoration: 'none' },
  button:         { width: '100%', padding: '14px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  buttonDisabled: { width: '100%', padding: '14px', backgroundColor: '#999', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'not-allowed', marginTop: '8px' },
  error:          { backgroundColor: '#ffe0e0', color: '#cc0000', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px', textAlign: 'center' },
  divider:        { borderTop: '1px solid #eee', margin: '24px 0' },
  newAccountText: { textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '12px' },
  createBtn:      { display: 'block', width: '100%', padding: '14px', backgroundColor: '#fff', color: '#1a1a2e', border: '2px solid #1a1a2e', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' },
};